export default __webpack_public_path__ + "static/media/bus.4690efdb.svg";